<template>
  <div class="home">
    <div class="logo">
      <img class="logo-img" src="@/assets/Images/LOGO.png" alt="">
    </div>
    <div class="nav">
     
      <div class="tool-wrap">
        <router-link tag="a" to="/snippets" style="width:100%;">
          <div class="tool">
            <div class="tool-img"><img src="@/assets/Icons/SnippetsIcon.svg" alt=""></div>
            <span class="tool-text">Snippets</span>
          </div>
        </router-link>
      </div>
      <div class="tool-wrap">
        <router-link tag="a" to="/wt3t" style="width:100%;">
          <div class="tool">
            <div class="tool-img"><img src="@/assets/Icons/SnippetsIcon.svg" alt=""></div>
            <span class="tool-text">WT3T</span>
          </div>
        </router-link>
      </div>
      <div class="tool-wrap-none">
        <!-- <router-link tag="a" to="/workday" style="width:100%;">
          <div class="tool">
            <div class="tool-img"><img src="@/assets/Icons/Workday.svg" alt=""></div>
            <span class="tool-text">Workday</span>
          </div>
        </router-link> -->
        <div style="width:100%;">
          <div class="tool">
            <div class="tool-img"><img src="@/assets/Images/feishu.png" alt=""></div>
            <span class="tool-text">Workday（已迁至飞书）</span>
          </div>
        </div>
      </div>
      <div class="tool-wrap">
        <router-link tag="a" to="/claim" style="width:100%;">
          <div class="tool">
            <div class="tool-img"><img src="@/assets/Icons/Claim.svg" alt=""></div>
            <span class="tool-text">Claim</span>
          </div>
        </router-link>
      </div>
      <div class="tool-wrap">
        <router-link tag="a" to="/dory" style="width:100%;">
          <div class="tool">
            <div class="tool-img"><img src="@/assets/Icons/Q&A.svg" alt=""></div>
            <span class="tool-text">Dory</span>
          </div>
        </router-link>
      </div>
       <div class="tool-wrap">
        <router-link tag="a" to="/team" style="width:100%;">
          <div class="tool">
            <div class="tool-img"><img src="@/assets/Icons/TeamIcon.svg" alt=""></div>
            <span class="tool-text">Team</span>
          </div>
        </router-link>
      </div>
      <a href="https://docs.google.com/spreadsheets/d/1VKNr5lV5I43vApkJZr4M8Vl1JhxK_3zfp6hgpw231o0/" target="_blank" class="tool-wrap">
        <div class="tool">
          <div class="tool-img"><img src="@/assets/Icons/training.svg" alt=""></div>
          <span class="tool-text">Training</span>
        </div>
      </a>
      <a href="https://truecolor.impronline.com/" target="_blank" class="tool-wrap">
        <div class="tool">
          <div class="tool-img"><img src="@/assets/Icons/True Color.svg" alt=""></div>
          <span class="tool-text">True Color</span>
        </div>
      </a>
      <a href="https://gpt.impr-inc.com/" target="_blank" class="tool-wrap">
        <div class="tool">
          <div class="tool-img"><img src="@/assets/Icons/chatbot.png" alt=""></div>
          <span class="tool-text">Diggo GPT</span>
        </div>
      </a>
      <div class="tool-wrap" v-if="adminRole">
        <router-link tag="a" to="/admin" style="width:100%;">
          <div class="tool">
            <div class="tool-img"><img src="@/assets/Icons/admin.svg" alt=""></div>
            <span class="tool-text">Admin</span>
          </div>
        </router-link>
      </div>
       <div class="tool-wrap" v-if="serverRole">
        <router-link tag="a" to="/server" style="width:100%;">
          <div class="tool">
            <div class="tool-img"><img src="@/assets/Icons/server.png" alt=""></div>
            <span class="tool-text">Server Status</span>
          </div>
        </router-link>
      </div>
      <div class="tool-wrap" v-if="serverRole">
        <router-link tag="a" to="/ads" style="width:100%;">
          <div class="tool">
            <div class="tool-img"><img src="@/assets/Icons/server.png" alt=""></div>
            <span class="tool-text">Ads Status</span>
          </div>
        </router-link>
      </div>
      <!-- <a href="http://data.silveropen.com/#/" target="_blank" class="tool-wrap">
        <div class="tool">
          <div class="tool-img"><img src="@/assets/Icons/G3 Sliver.svg" alt=""></div>
          <span class="tool-text">G3 Dashboard</span>
        </div>
      </a>
      <a href="http://192.168.1.5/articletool/" target="_blank" class="tool-wrap">
        <div class="tool">
          <div class="tool-img"><img src="@/assets/Icons/G3 Artical.svg" alt=""></div>
          <span class="tool-text">G3 Article Tool</span>
        </div>
      </a>
      <a href="http://192.168.1.5/Gametool/adstool/" target="_blank" class="tool-wrap">
        <div class="tool">
          <div class="tool-img"><img src="@/assets/Icons/Game tool.svg" alt=""></div>
          <span class="tool-text">G3 Game Ads Tool</span>
        </div>
      </a>
      <a href="http://192.168.1.2/Tool_ArticleInput/" target="_blank" class="tool-wrap">
        <div class="tool">
          <div class="tool-img"><img src="@/assets/Icons/G4 Artical.svg" alt=""></div>
          <span class="tool-text">G4 Article Tool</span>
        </div>
      </a>
      <a href="https://push.silversiri.com/" target="_blank" class="tool-wrap">
        <div class="tool">
          <div class="tool-img"><img src="@/assets/Icons/G4 Push.svg" alt=""></div>
          <span class="tool-text">G4 Push Tool</span>
        </div>
      </a>
      <a href="https://tool.silvernico.com/dist/#/" target="_blank" class="tool-wrap">
        <div class="tool">
          <div class="tool-img"><img src="@/assets/Icons/G5 Silver.svg" alt=""></div>
          <span class="tool-text">G5 Dashboard</span>
        </div>
      </a> -->
    </div>
    <Bug></Bug>
  </div>
</template>

<script>
import api from '@/common/api.js'
import Bug from './Bug.vue'

export default {
  name: 'Home',
  data() {
    return {
      curUserId: '',
      adminRole:false,
      serverRole:false,
    }
  },
  components: {
    Bug
  },
  methods: {
    getUserList() {
      this.$post(api.tool.getUserList, {
        timestamp: Date.parse(new Date()),
        token: localStorage.impr_token,
        employee_id: this.curUserId,
      }).then((res) => {
        if (res.code === 200) {
          console.log('ok')
        }
      })
    },
  },
  created() {
    // localStorage.work_sub = '106447235921398701873'
    // localStorage.impr_name = '夏雨'
    // localStorage.impr_email = 'xiayu@impr-inc.com'
    // localStorage.impr_picture = 'https://lh3.googleusercontent.com/a-/AOh14GiYtSw9cV5fmBtOtn5PNSUFEOWBc3d1xqd6x1vy=s96-c'
    // localStorage.impr_id = '138'
    // localStorage.impr_token = 'MTk5MzYxMDc1OF8xNjgwNTEyNzAwXzE0OTYyMzgwMjY='
    // localStorage.impr_id = '214'
    // localStorage.impr_token = 'MjQ0ODYwMzg5XzE2ODE4OTY1NTVfNDA1NTEzMTU2'
    // console.log(localStorage.impr_id)
    // if(localStorage.impr_id == '138') {
    //   localStorage.removeItem('impr_token')
    //   localStorage.removeItem('impr_id')
    //   this.$router.push({ path: '/login' })
    // }
    if (localStorage.impr_id && localStorage.impr_token) {
      this.curUserId = localStorage.impr_id
      this.getUserList()
      this.$post(api.tool.getRole,{
        timestamp: Date.parse(new Date()),
        token: localStorage.impr_token,
        employee_id: this.curUserId,
      }).then((res) => {
        if(res.code === 200) {
          res.list.forEach(item => {
            if(item.role_id == 1) {
              this.adminRole = true
            }
            if(item.role_id == 2) {
              this.serverRole = true
            }
          });
        }
      })
    } else {
      this.$router.push({ path: '/login' })
    }
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.home {
  margin-top: 178px;
}
.logo {
  display: flex;
  justify-content: center;
  width: 100%;
}
.logo-img {
  height: 115px;
}
.nav {
  margin: 0 auto;
  text-align: center;
  width: 1000px;
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  margin-top: 80px;
}
.tool-wrap-none,
.tool-wrap {
  width: 25%;
  height: 184px;
  border-radius: 16px;
  display: flex;
}
.tool {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.tool-wrap:hover {
  background-color: rgba(33, 119, 233, 0.08);
}
.tool-img {
  width: 88px;
  height: 88px;
  border-radius: 50%;
  background-color: #fafafa;
  display: flex;
  justify-content: center;
  align-items: center;
}
.tool-img img {
  width: 40px;
  height: 40px;
}
.tool-text {
  display: inline-block;
  margin-top: 20px;
  font-size: 14px;
  color: #000;
}
.tool-wrap:hover .tool-text {
  color: #1890ff;
}

.home-icon {
  width: 70px;
  height: 70px;
}

</style>
